module.exports = __webpack_public_path__ + "media/images/actions-fill-topbar-0a82e3d3bef35026c9b2452a096168b7.svg";